import { v4 as uuid } from 'uuid';
import { timezones } from '../../utils/timezones';
import { generateRowLabels } from '../FormBuilder/FormComponents/Table/TableHelpers';
import useProjectStore from '../ProjectCanvas/useProjectStore';

class Container {
  constructor() {
    this.endpoint = this.type === 'form_section' ? 'form_section' : 'sequential_form';
    this.pages = [];
    this.node = '';
    this.editTarget = '';
    this.onEdit = false;
    this.pageTitles = [{ page_title: 'Page Title', page_description: '' }];
    this.position = null;
    this.dataQuestion = [];
    this.movedQuestions = [];
    this._listeners = new Set();
    this._componentId = null;
    this._syncTimer = null;
    this.message =
      '<p>Hello</p> \n <p>You have been assigned a task to complete. To open and view this task, click the button at the end of this email.</p> \n <p>Link to task: !{taskURL}</p>';
    this.notificationMethod = 'email';
    this.email = [];
    this.emailSubject = 'You have been assigned a task to complete';
    this.users = [];
    this.dueDateStatus = 'no_due_date';
    this.dueDatePeriod = 'null';
    this.dueDateOn = [];
    this.reminderUsers = [];
    this.placeholders = [];
    this.SelectedPlaceholder = {};
    this.disableButtonsWhileLoading = false;
    this.reminderEmailMessage = '';
    this.reminderEmail = [];
    this.reminderCcEmails = [];
    this.reminderReplyToEmails = [];
    this.reminderEmailSubject = '';
    this.reminderInterval = 1;
    this.reminderType = 'default';
    this.reminderTimezone = 'GMT+10';
    this.reminderFrequency = 'ONCE';
    this.reminder = false;
    this.reminderLimit = 1;
    this.reminderOption = 'time';
    this.reminderOnPlaceholderValue = [];
    this.toDoColor = '';
    this.toDoLabel = '';
    this.completedColor = '';
    this.completedLabel = '';
    this.credentialId = null;
    this.onSave = false;
    this.columnId = '';
    this.databaseId = '';
    this.ccEmails = [];
    this.replyToEmails = [];
    this.validation = {
      min: '',
      max: '',
      message: '',
      regex: '',
    };
  }
  getNotificationMethod = () => {
    return this.notificationMethod;
  };

  setNotificationMethod = notificationMethod => {
    this.notificationMethod = notificationMethod;
  };

  getDueDateStatus = () => {
    return this.dueDateStatus;
  };

  setDueDateStatus = dueDateStatus => {
    this.dueDateStatus = dueDateStatus;
  };

  getCredentialId = () => {
    return this.credentialId;
  };

  setCredentialId = credentialId => {
    this.credentialId = credentialId;
  };

  getReminderOption = () => {
    return this.reminderOption;
  };

  setReminderOption = reminderOption => {
    this.reminderOption = reminderOption;
  };

  getReminderLimit = () => {
    return this.reminderLimit;
  };

  setReminderLimit = limit => {
    this.reminderLimit = limit;
  };

  setReminderInterval = interval => {
    this.reminderInterval = interval;
  };

  getReminderFrequency = () => {
    return this.reminderFrequency;
  };

  setReminderFrequency = frequency => {
    this.reminderFrequency = frequency;
  };

  getReminderType = () => {
    switch (this.reminderType) {
      case 'minutes':
        return 1;
        break;
      case 'hours':
        return 2;
        break;
      case 'days':
        return 3;
        break;
      case 'weeks':
        return 4;
        break;
      case 'months':
        return 5;
        break;
      case 'businessDays':
        return 6;
        break;
    }
  };

  setReminderType = type => {
    let intervalType = '';
    switch (type) {
      case 1:
        intervalType = 'minutes';
        break;
      case 2:
        intervalType = 'hours';
        break;
      case 3:
        intervalType = 'days';
        break;
      case 4:
        intervalType = 'weeks';
        break;
      case 5:
        intervalType = 'months';
        break;
      case 6:
        intervalType = 'businessDays';
        break;
    }
    this.reminderType = intervalType;
  };

  setReminderMessage = html => {
    this.reminderEmailMessage = html;
  };
  getReminderEmailMessage = html => {
    return this.reminderEmailMessage;
  };

  setMessage = html => {
    this.message = html;
  };
  subscribe(fn) {
    this._listeners.add(fn);
    return () => this._listeners.delete(fn);
  }

  notify() {
    this._listeners.forEach(fn => fn());
    this._scheduleSyncToStore();
  }

  _scheduleSyncToStore() {
    if (this._syncTimer) clearTimeout(this._syncTimer);
    this._syncTimer = setTimeout(() => {
      this._syncTimer = null;
      this._syncToProjectStore();
    }, 150);
  }

  _syncToProjectStore() {
    const cid = this._componentId;
    if (!cid) return;
    try {
      const saved = this.saveTemplate();
      const hasContent = Array.isArray(saved.pages) && saved.pages.some(p => p.fields?.length > 0);
      if (!hasContent) return;
      const comps = useProjectStore.getState().components;
      if (!comps) return;
      const idx = comps.findIndex(c => c.componentId === cid);
      if (idx === -1) return;
      const liveData = {
        ...comps[idx].rawComponentData,
        pages: saved.pages,
        formLength: Object.keys(saved.pages).length,
        email: this.email || [],
        notificationMethod: {
          method: this.notificationMethod || 'email',
          credentialId: this.credentialId,
        },
        taskDueDate: {
          status: this.dueDateStatus || 'no_due_date',
          dueDateAfter: null,
          dueDatePeriod: this.dueDatePeriod || null,
          dueDateOn: this.dueDateOn || null,
        },
        toDoLabel: this.toDoLabel || '',
        completedLabel: this.completedLabel || '',
        toDoColor: this.toDoColor || '',
        completedColor: this.completedColor || '',
      };
      const updated = [...comps];
      updated[idx] = { ...updated[idx], rawComponentData: liveData };
      useProjectStore.setState({ components: updated });
    } catch (_) { /* swallow — preview is best-effort */ }
  }

  addToMovedQuestions(component) {
    this.movedQuestions.push(component);
  }
  getMovedQuestions() {
    return this.movedQuestions;
  }
  emptyMovedQuestions() {
    this.movedQuestions.length = 0;
  }
  setPosition(pst) {
    this.position = pst;
  }
  editPagedata(id, data, type) {
    let index = this.pages.findIndex(function (element) {
      return element.id == id;
    });
    if (index >= 0) {
      if (this.pages[index].config) {
        this.pages[index].config[type] = data;
      } else {
        this.pages[index].config = { [type]: data };
      }
    }
    this.notify();
  }
  copyItem = id => {
    //find the card to be copied
    const data = this.pages;
    const filterArray = [];
    var idx = 0;
    let result = data.filter(item => item.id == id);
    for (let index = 0; index < data.length; index++) {
      if (data[index].id == result[0].id) {
        filterArray.push(data[index]);
        idx = index;
        break;
      }
    }
    var toBeCopied = result[0];
    var copy = JSON.parse(JSON.stringify(toBeCopied));
    //create new id for the node
    copy.id = uuid();
    //create new key for the question
    copy.config.key =
      copy.text.replace(' ', '') + (Math.floor(Math.random() * 90000000) + 10000).toString();
    //add to the next position in the cards array
    copy.config.placeholderValue = null;
    this.pages.splice(idx + 1, 0, copy);
    this.notify();
  };
  getPage() {
    return this.pages;
  }
  saveConfig = data => {
    const targetId = this.editTarget.id;
    let index = this.pages.findIndex(function (element) {
      return element.id == targetId;
    });
    if (index >= 0) {
      this.pages[index].config = data;
    }
    this.notify();
  };
  convertFormat = type => {
    switch (type) {
      case 1:
        return 'number_input';
      case 2:
        return 'free_text';
      case 3:
        return 'custom_map';
      case 4:
        return 'single_choice';
      case 5:
        return 'multiple_choice';
      case 6:
        return 'upload_media';
      case 7:
        return 'calendar';
      case 8:
        return '';
      case 9:
        return 'single_line_text';
      case 10:
        return 'single_select';
      case 11:
        return 'row_text';
      case 12:
        return 'list_input';
      case 13:
        return 'e_signature';
      case 14:
        return 'file_preview';
      case 15:
        return 'table';
      case 16:
        return 'video_embed';
      case 17:
        return 'rich_text_editor';
      case 19:
        return 'repeatable_section';
      case 20:
        return 'image_annotation';
      case 21:
        return 'address';
      default:
        return '';
    }
  };
  encodeObj = type => {
    switch (type) {
      case 'number':
      case 'number_input':
        return { type: 1, text: 'Number Input' };
      case 'long_text':
      case 'free_text':
        return {
          type: 2,
          text: 'Long Text',
        };
      case 'map':
      case 'custom_map':
        return {
          type: 3,
          text: 'Map',
        };
      case 'radio_button':
      case 'single_choice':
        return {
          type: 4,
          text: 'Radio Button',
        };
      case 'checkbox':
      case 'multiple_choice':
        return {
          type: 5,
          text: 'Checkbox',
        };
      case 'file_upload':
      case 'upload_media':
        return {
          type: 6,
          text: 'Upload File',
        };
      case 'date':
      case 'calendar':
        return {
          type: 7,
          text: 'Calendar',
        };
      case 'short_text':
      case 'single_line_text':
        return {
          type: 9,
          text: 'Short Text',
        };
      case 'dropdown':
      case 'single_select':
        return {
          type: 10,
          text: 'Dropdown',
        };
      case 'content_block':
      case 'row_text':
        return {
          type: 11,
          text: 'Content Block',
        };
      case 'list':
      case 'list_input':
        return {
          type: 12,
          text: 'List Input',
        };
      case 'signature':
      case 'e_signature':
        return {
          type: 13,
          text: 'E-Signature',
        };
      case 'file_preview':
        return {
          type: 14,
          text: 'File preview',
        };
      case 'table':
        return {
          type: 15,
          text: 'Table',
        };
      case 'embed_video':
      case 'video_embed':
        return {
          type: 16,
          text: 'Embed video',
        };

      case 'rich_text':
      case 'rich_text_editor':
        return {
          type: 17,
          text: 'Rich Text Editor',
        };
      case 'repeatable_section':
        return {
          type: 19,
          text: 'Repeatable Section',
        };
      case 'image_annotation':
        return {
          type: 20,
          text: 'Image Annotation',
        };
      case 'address':
        return {
          type: 21,
          text: 'Address',
        };
      default:
        return '';
    }
  };
  parseJSON = data => {
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  };
  clearStorage = () => {
    this.pages = [];
    this.editTarget = '';
    this.onEdit = false;
    this.onSave = false;
    this.pageTitles = [{ page_title: 'Page Title', page_description: '' }];
    this.credentialId = null;
    this.SelectedPlaceholder = {};
  };

  _isV2Pages = (data) => {
    if (Array.isArray(data)) return true;
    const firstKey = Object.keys(data || {})[0];
    if (firstKey == null) return false;
    const firstPage = data[firstKey];
    return firstPage && (Array.isArray(firstPage.fields) || typeof firstPage.title === 'string');
  };

  _parseV2Field = (f) => {
    let obj = this.encodeObj(f.type);
    if (!obj) return null;
    obj.id = uuid();
    obj.config = {
      required: f.required ?? false,
      requiredText: f.required ?? false,
      visibility: f.visible ?? f.visibility ?? true,
      visibilityText: f.visible ?? f.visibility ?? true,
      readonly: f.readOnly ?? f.read_only ?? false,
      readonlyText: f.readOnly ?? f.read_only ?? false,
      comment: f.comment ?? false,
      autoAnswer: f.prefill ?? f.auto ?? '',
      auto_answer: f.prefill ?? f.auto ?? '',
      dataAuto: this.dataAuto(f.key_active_auto),
      dataVisibility: this.dataVisibility(f.key_visibility),
      dataReadOnly: this.dataReadOnly(f.key_readonly),
      dataRequired: this.dataRequired(f.key_required),
      dataComment: this.dataComment(f.key_comment),
      question_description_default: f.description ?? '',
      question_text_default: f.label ?? '',
      key: f.key ?? '',
      answer_list: f.options ?? [['', '']],
      answer_data_default: f.options || f.fileUrl || f.rte_answer_data_default || f.defaultContent || '',
      defaultContent: f.defaultContent ?? '',
      drop_down: f.searchable ? 'true' : '',
      numRows: parseInt(f.numRows ?? f.minRows ?? 3),
      exportType: f.exportType ?? 'columnsAsLists',
      exportFormat: f.exportFormat ?? 'JSON',
      tableCells: f.tableCells ?? (!Array.isArray(f.columns) && typeof f.columns === 'object' && f.columns !== null ? f.columns : {}),
      columns: Array.isArray(f.columns) ? f.columns : [],
      rowLabels: f.rowLabels ?? generateRowLabels(parseInt(f.numRows ?? 3)),
      minItems: parseInt(f.minItems ?? f.minSections ?? 0),
      maxItems: parseInt(f.maxItems ?? f.maxSections ?? 0),
      outputFormat: f.outputFormat ?? '',
      timezone: f.timezone ?? '',
      databaseId: f.databaseId ?? '',
      columnId: f.columnId ?? '',
      labelColumnId: f.labelColumnId ?? '',
      valueColumnId: f.valueColumnId ?? '',
      file_type: f.fileType ?? f.file_type ?? 'pdf',
      sourceMode: f.sourceMode ?? 'user_upload',
      presetImageUrl: f.presetImageUrl ?? '',
      addressFields: f.addressFields ?? {
        line1: { show: true, required: true },
        line2: { show: true, required: false },
        locality: { show: true, required: true },
        region: { show: true, required: true },
        postalCode: { show: true, required: true },
        country: { show: true, required: true },
      },
      notificationEmails: f.notificationEmails ?? null,
      optionsSource: f.optionsSource ?? 'manually',
      size: f.size ?? 'RESPONSIVE',
      height: f.height ?? '',
      width: f.width ?? '',
      embedType: f.embedType ?? 'URL',
      url: f.url ?? '',
      snippet: f.snippet ?? '',
      validation: f.validation
        ? { regex: f.validation.regex || '', min: f.validation.min ?? '', max: f.validation.max ?? '', message: f.validation.message || '' }
        : { regex: '', min: '', max: '', message: '' },
    };
    return obj;
  };

  _parseV1Field = (component) => {
    const views = component.views;
    const objToEncode = component.type
      ? component.type
      : views?.answer ? views.answer.view.format
      : views?.question ? views.question.view.format
      : null;
    if (!objToEncode) return null;
    let obj = this.encodeObj(objToEncode);
    if (!obj) return null;
    obj.id = uuid();
    obj.config = {
      required: component.required,
      requiredText: component.required,
      visibility: component.visibility,
      visibilityText: component.visibility,
      readonly: component.read_only,
      readonlyText: component.readonly,
      comment: component.comment,
      autoAnswer: component.auto,
      auto_answer: component.auto,
      dataAuto: this.dataAuto(component.key_active_auto),
      dataVisibility: this.dataVisibility(component.key_visibility),
      dataReadOnly: this.dataReadOnly(component.key_readonly),
      dataRequired: this.dataRequired(component.key_required),
      dataComment: this.dataComment(component.key_comment),
      question_description_default: component.views?.question?.description?.default ?? '',
      question_text_default: component.views?.question?.view?.data?.default ?? '',
      key: component.key,
      answer_list: this.parseJSON(component.views?.answer?.view?.data?.default) || [['', '']],
      answer_data_default: component.rte_answer_data_default || this.parseJSON(component.views?.answer?.view?.data?.default),
      defaultContent: this.parseJSON(component.views?.answer?.view?.data?.default),
      drop_down: component.drop_down,
      numRows: parseInt(component.numRows),
      exportType: component.exportType,
      exportFormat: component.exportFormat,
      tableCells: component.tableCells || component.columns || {},
      columns: this.parseJSON(component.views?.answer?.view?.data?.default) ?? [],
      rowLabels: component.views?.answer?.view?.data?.rowLabels
        ? component.views.answer.view.data.rowLabels
        : generateRowLabels(parseInt(component.numRows)),
      minItems: parseInt(component.minItems ?? component.list_min),
      maxItems: parseInt(component.maxItems ?? component.list_max),
      outputFormat: component.outputFormat,
      timezone: component.timezone,
      databaseId: component.databaseId,
      columnId: component.columnId,
      labelColumnId: component.labelColumnId,
      valueColumnId: component.valueColumnId,
      file_type: component.file_type,
      sourceMode: component.sourceMode || component.annotationSourceMode || 'user_upload',
      presetImageUrl: component.presetImageUrl || '',
      addressFields: component.addressFields || component.addressFieldConfig || {
        line1: { show: true, required: true },
        line2: { show: true, required: false },
        locality: { show: true, required: true },
        region: { show: true, required: true },
        postalCode: { show: true, required: true },
        country: { show: true, required: true },
      },
      notificationEmails: component.notificationEmails,
      optionsSource: component.optionsSource || component.choiceAnswerOption,
      size: component.size,
      height: component.height,
      width: component.width,
      embedType: component.embedType,
      url: component.url,
      snippet: component.snippet,
      validation: component.validation
        ? { regex: component.validation.regex || '', min: component.validation.min || '', max: component.validation.max || '', message: component.validation.message || '' }
        : { regex: '', min: '', max: '', message: '' },
    };
    return obj;
  };

  reloadTemplate = (data, form_length) => {
    try {
      SequentialFormContainer.clearStorage();
      const isV2 = this._isV2Pages(data);

      const pagesArray = isV2
        ? (Array.isArray(data) ? data : Object.keys(data).sort((a, b) => Number(a) - Number(b)).map(k => data[k]))
        : null;
      const effectiveFormLength = isV2
        ? (pagesArray ? pagesArray.length : 0)
        : parseInt(form_length);

      if (isV2) {
        for (let idx = 0; idx < pagesArray.length; idx++) {
          const page = pagesArray[idx];
          const fields = page.fields ?? page.components ?? [];
          for (const f of fields) {
            const isV2Field = f.label !== undefined || (f.type && !f.views);
            const obj = isV2Field ? this._parseV2Field(f) : this._parseV1Field(f);
            if (obj) this.pages.push(obj);
          }
          if (idx === 0) {
            const pageTitle = typeof page.title === 'string' ? page.title : page.title?.view?.data?.default ?? '';
            const pageDesc = typeof page.description === 'string' ? page.description : page.title?.description?.default ?? '';
            this.pageTitles = [{ page_title: pageTitle, page_description: pageDesc }];
          }
          if (idx < pagesArray.length - 1) {
            const nextPage = pagesArray[idx + 1];
            const nextTitle = typeof nextPage.title === 'string' ? nextPage.title : nextPage.title?.view?.data?.default ?? '';
            const nextDesc = typeof nextPage.description === 'string' ? nextPage.description : nextPage.title?.description?.default ?? '';
            this.pages.push({
              id: uuid(),
              type: 8,
              text: 'Page Breaker',
              config: { page_title: nextTitle, page_description: nextDesc },
            });
          }
        }
      } else {
        for (let key in data) {
          const pageFields = data[key].components ?? [];
          for (const component of pageFields) {
            const obj = this._parseV1Field(component);
            if (obj) this.pages.push(obj);
          }
          if (key == 0) {
            this.pageTitles = [
              {
                page_title: data[key].title?.view?.data?.default ?? '',
                page_description: data[key].title?.description?.default ?? '',
              },
            ];
          }
          if (key < effectiveFormLength - 1) {
            this.pages.push({
              id: uuid(),
              type: 8,
              text: 'Page Breaker',
              config: {
                page_title: data[parseInt(key) + 1]?.title?.view?.data?.default ?? '',
                page_description: data[parseInt(key) + 1]?.title?.description?.default ?? '',
              },
            });
          }
        }
      }
    } catch (e) {
      // Swallow reloadTemplate errors (original behavior)
    }
  };
  getKeyButtonGroup = data => {
    if (data) {
      const obj = data.filter(ele => ele.active == true);
      if (obj && obj[0]) {
        return obj[0].key;
      }
    }
    return '';
  };
  _serializeV2Field = (n) => {
    const type = this.convertFormat(n.type);
    const field = {
      key: n.config.key || n.text.replace(/ /g, '') + (Math.floor(Math.random() * 90000000) + 10000).toString(),
      type,
      label: n.config.question_text_default ?? '',
      description: n.config.question_description_default ?? '',
      required: n.config.required ?? false,
      readOnly: n.config.readonly ?? false,
      visible: n.config.visibility ?? true,
      prefill: n.config.autoAnswer || null,
      comment: n.config.comment ?? false,
      key_active_auto: this.getKeyButtonGroup(n.config.dataAuto),
      key_visibility: this.getKeyButtonGroup(n.config.dataVisibility),
      key_readonly: this.getKeyButtonGroup(n.config.dataReadOnly),
      key_required: this.getKeyButtonGroup(n.config.dataRequired),
      key_comment: this.getKeyButtonGroup(n.config.dataComment),
      notificationEmails: n.config.notificationEmails ?? null,
    };

    if (n.type == 4 || n.type == 5 || n.type == 10) {
      const list = n.config.answer_list ?? [['', '']];
      for (let i in list) {
        if (!list[i][0]) list[i][0] = list[i][1];
      }
      field.options = list;
      field.optionsSource = n.config.optionsSource ?? 'manually';
      field.searchable = n.config.drop_down === 'true' || n.config.drop_down === true;
      field.databaseId = n.config.databaseId ?? null;
      field.labelColumnId = n.config.labelColumnId ?? null;
      field.valueColumnId = n.config.valueColumnId ?? null;
    }

    if (n.type == 15) {
      field.columns = n.config.columns ?? [];
      field.tableCells = n.config.tableCells ?? {};
      field.numRows = n.config.numRows;
      field.rowLabels = n.config.rowLabels;
      field.exportType = n.config.exportType;
      field.exportFormat = n.config.exportFormat;
    }

    if (n.type == 19) {
      field.columns = n.config.columns;
      field.tableCells = n.config.tableCells ?? {};
      field.minSections = n.config.minItems ?? 0;
      field.maxSections = n.config.maxItems ?? 0;
    }

    if (n.type == 12) {
      field.minItems = n.config.minItems ?? 0;
      field.maxItems = n.config.maxItems ?? 0;
    }

    if (n.type == 7) {
      field.outputFormat = n.config.outputFormat ?? '';
      field.timezone = n.config.timezone ?? '';
    }

    if (n.type == 11) {
      field.defaultContent = n.config.answer_data_default ?? n.config.defaultContent ?? '';
    }

    if (n.type == 17) {
      field.defaultContent = n.config.defaultContent ?? '';
    }

    if (n.type == 14) {
      field.fileType = n.config.file_type ?? 'pdf';
      field.fileUrl = n.config.answer_data_default ?? '';
    }

    if (n.type == 16) {
      field.embedType = n.config.embedType ?? 'URL';
      field.url = n.config.url ?? '';
      field.snippet = n.config.snippet ?? '';
      field.size = n.config.size ?? 'RESPONSIVE';
      field.height = n.config.height ?? '';
      field.width = n.config.width ?? '';
    }

    if (n.type == 20) {
      field.sourceMode = n.config.sourceMode ?? 'user_upload';
      field.presetImageUrl = n.config.presetImageUrl ?? '';
    }

    if (n.type == 21) {
      field.addressFields = n.config.addressFields;
    }

    if (n.config.validation && (n.config.validation.regex || n.config.validation.min || n.config.validation.max || n.config.validation.message)) {
      field.validation = {
        regex: n.config.validation.regex || undefined,
        min: n.config.validation.min ?? undefined,
        max: n.config.validation.max ?? undefined,
        message: n.config.validation.message || undefined,
      };
    }

    field.views = {
      question: {
        view: { format: 'row_text', data: { default: n.config.question_text_default, dynamic: '' } },
        style: '',
        description: { default: n.config.question_description_default, dynamic: '' },
      },
      answer: {
        view: {
          format: this.convertFormat(n.type),
          data: {
            rowLabels: n.config.rowLabels,
            default: n.type == 4 || n.type == 5 || n.type == 10
              ? n.config.answer_list
              : n.type == 15 || n.type == 19
              ? n.config.columns
              : n.type == 17
              ? n.config.defaultContent
              : n.config.answer_data_default,
            dynamic: '',
          },
        },
        style: '',
        description: { default: '', dynamic: '' },
      },
    };

    return field;
  };

  saveTemplate() {
    const pages = [];
    let currentPage = {
      title: this.pageTitles[0]?.page_title ?? '',
      description: this.pageTitles[0]?.page_description ?? '',
      fields: [],
    };

    this.pages.forEach(n => {
      if (n.type == 8) {
        pages.push(currentPage);
        currentPage = {
          title: n.config.page_title ?? '',
          description: n.config.page_description ?? '',
          fields: [],
        };
      } else {
        currentPage.fields.push(this._serializeV2Field(n));
      }
    });
    pages.push(currentPage);

    return { pages, form_length: pages.length };
  }

  dataAuto = key => {
    const data = [
      { key: 1, name: 'ON', active: false },
      { key: 2, name: 'OFF', active: true },
      { key: 3, name: 'CONDITIONAL', active: false },
    ];
    return this.changeButtonGroup(data, key);
  };

  dataVisibility = key => {
    const data = [
      { key: 1, name: 'ON', active: true },
      { key: 2, name: 'OFF', active: false },
      { key: 3, name: 'CONDITIONAL', active: false },
    ];
    return this.changeButtonGroup(data, key);
  };

  dataReadOnly = key => {
    const data = [
      { key: 1, name: 'ON', active: false },
      { key: 2, name: 'OFF', active: true },
      { key: 3, name: 'CONDITIONAL', active: false },
    ];
    return this.changeButtonGroup(data, key);
  };

  dataRequired = key => {
    const data = [
      { key: 1, name: 'ON', active: false },
      { key: 2, name: 'OFF', active: true },
      { key: 3, name: 'CONDITIONAL', active: false },
    ];
    return this.changeButtonGroup(data, key);
  };

  dataComment = key => {
    const data = [
      { key: 1, name: 'ON', active: false },
      { key: 2, name: 'OFF', active: true },
    ];
    return this.changeButtonGroup(data, key);
  };

  changeButtonGroup = (data, key) => {
    if (key) {
      const dataChange = data.map(item => {
        if (item.key === key) {
          return { ...item, active: true };
        } else {
          return { ...item, active: false };
        }
      });
      return dataChange;
    }
    return data;
  };

  setComponentAndPosition(originalData, index) {
    const data = { ...originalData };
    const id = uuid();
    const dataAuto = this.dataAuto();
    const dataVisibility = this.dataVisibility();
    const dataReadOnly = this.dataReadOnly();
    const dataRequired = this.dataRequired();
    const dataComment = this.dataComment();

    let colId = uuid();

    data.id = id;
    data.config = {
      required: false,
      requiredText: '',
      comment: false,
      visibility: true,
      visibilityText: '',
      readonly: false,
      readonlyText: '',
      autoAnswer: '',
      auto_answer: '',
      notificationEmails: {
        emailList: [],
        shouldNotify: false,
      },
      optionsSource: 'manually',
      dataAuto: dataAuto,
      dataVisibility: dataVisibility,
      dataReadOnly: dataReadOnly,
      dataRequired: dataRequired,
      dataComment: dataComment,
      question_description_default: '',
      question_text_default: '',
      key: data.text.replace(/ /g, '') + (Math.floor(Math.random() * 90000000) + 10000).toString(),
      answer_list: [['', '']],
      answer_data_default: '',
      defaultContent: '',
      drop_down: '',
      numRows: 3,
      exportType: 'columnsAsLists',
      exportFormat: 'JSON',
      columns: [
        {
          id: colId,
          type: 'text',
          columnName: 'Column 1',
          question: 'Question 1',
          description: '',
          options: [
            {
              id: uuid(),
              value: '',
              label: '',
            },
          ],
          dtFormat: {
            outputFormat: 'dd/MM/YYYY kk:mm',
            timezone: 'GMT+10',
          },
          required: false,
        },
      ],
      rowLabels: [
        {
          rowNumber: '1',
          rowLabel: '',
          rowKey: 'row1',
        },
        {
          rowNumber: '2',
          rowLabel: '',
          rowKey: 'row2',
        },
        {
          rowNumber: '3',
          rowLabel: '',
          rowKey: 'row3',
        },
      ],
      minItems: 0,
      maxItems: 0,
      outputFormat: '',
      timezone:
        timezones.find(timezone => timezone.name === useProjectStore.getState().timezone)?.offset || '',
      databaseId: '',
      columnId: '',
      valueColumnId: '',
      labelColumnId: '',
      page_title: 'Page Title',
      file_type: 'pdf',
      sourceMode: 'user_upload',
      presetImageUrl: '',
      addressFields: {
        line1: { show: true, required: true },
        line2: { show: true, required: false },
        locality: { show: true, required: true },
        region: { show: true, required: true },
        postalCode: { show: true, required: true },
        country: { show: true, required: true },
      },
      size: 'RESPONSIVE',
      height: '',
      width: '',
      embedType: 'URL',
      url: '',
      snippet: '',
      validation: {
        regex: '',
        min: '',
        max: '',
        message: '',
      },
    };

    // Simple: just insert at the requested index
    this.pages.splice(index, 0, data);
    this.notify();
  }

  addComponent = originalData => {
    const data = { ...originalData };
    const id = uuid();
    const dataAuto = this.dataAuto();
    const dataVisibility = this.dataVisibility();
    const dataReadOnly = this.dataReadOnly();
    const dataRequired = this.dataRequired();
    const dataComment = this.dataComment();

    data.id = id;

    let colId = uuid();

    data.config = {
      required: false,
      requiredText: '',
      comment: false,
      visibility: true,
      visibilityText: '',
      readonly: false,
      readonlyText: '',
      autoAnswer: '',
      auto_answer: '',
      notificationEmails: {
        emailList: [],
        shouldNotify: false,
      },
      optionsSource: 'manually',
      dataAuto: dataAuto,
      dataVisibility: dataVisibility,
      dataReadOnly: dataReadOnly,
      dataRequired: dataRequired,
      dataComment: dataComment,
      question_description_default: '',
      question_text_default: '',
      // Changed the replace method to replace all spaces in the text
      key: data.text.replace(/ /g, '') + (Math.floor(Math.random() * 90000000) + 10000).toString(),
      answer_list: [['', '']],
      answer_data_default: '',
      defaultContent: '',
      drop_down: '',
      numRows: 3,
      exportType: 'columnsAsLists',
      exportFormat: 'JSON',
      columns: [
        {
          id: colId,
          type: 'text',
          columnName: 'Column 1',
          question: 'Question 1',
          description: '',
          options: [
            {
              id: uuid(),
              value: '',
              label: '',
            },
          ],
          dtFormat: {
            outputFormat: 'dd/MM/YYYY kk:mm',
            timezone: 'GMT+10',
          },
          required: false,
        },
      ],
      rowLabels: [
        {
          rowNumber: '1',
          rowLabel: '',
          rowKey: 'row1',
        },
        {
          rowNumber: '2',
          rowLabel: '',
          rowKey: 'row2',
        },
        {
          rowNumber: '3',
          rowLabel: '',
          rowKey: 'row3',
        },
      ],
      minItems: 0,
      maxItems: 0,
      outputFormat: '',
      timezone: '',
      page_title: 'Page Title',
      databaseId: '',
      columnId: '',
      valueColumnId: '',
      labelColumnId: '',
      file_type: 'pdf',
      sourceMode: 'user_upload',
      presetImageUrl: '',
      addressFields: {
        line1: { show: true, required: true },
        line2: { show: true, required: false },
        locality: { show: true, required: true },
        region: { show: true, required: true },
        postalCode: { show: true, required: true },
        country: { show: true, required: true },
      },
      size: 'RESPONSIVE', //the size for the embedded video
      height: '',
      width: '',
      embedType: 'URL',
      url: '',
      snippet: '',
      validation: {
        regex: '',
        min: '',
        max: '',
        message: '',
      },
    };
    this.pages.push(data);
    this.notify();
  };
  editComponent = id => {
    const data = this.pages;
    const filterArray = [];

    let result = data.filter(item => item.id == id);
    if (!result.length) {
      console.warn('[SequentialFormContainer] editComponent: no page found with id', id);
      return;
    }

    for (let index = 0; index < data.length; index++) {
      if (data[index].id == result[0].id) break;
      filterArray.push(data[index]);
    }

    this.dataQuestion = filterArray;
    this.editTarget = result[0];
  };

  reloadEditComponent = () => {
    this.editTarget = '';
  };

  setSubject = subject => {
    this.emailSubject = subject;
  };
  getData = id => {
    let result = this.pages.filter(item => item.id == id);
    return result[0];
  };
  clearPage = id => {
    let currentIndex = this.pages.findIndex(item => item.id == id);
    this.pages.splice(currentIndex, 1);

    if (currentIndex >= 0) {
      for (let i = currentIndex; i < this.pages.length; i++) {
        if (this.pages[i].type != 8) {
          this.pages[i] = '';
        } else {
          break;
        }
      }
      this.pages = this.pages.filter(item => item != '');
    }
    this.notify();
  };
  deletePageKeepQuestions = id => {
    let currentIndex = this.pages.findIndex(item => item.id == id);
    let leftover_array = this.pages.slice(currentIndex, this.pages.length + 1);
    this.pages.splice(currentIndex, 1);
    this.pages.concat(leftover_array);
    this.notify();
  };

  get template() {
    const savedTemplate = this.saveTemplate();
    return {
      componentId: this.componentId,
      name: this.name,
      data: {
        componentData: {
          schemaVersion: 2,
          formTitle: this.pageTitles[0]?.page_title || 'Form Title',
          email: this.email[0] || '',
          ccEmails: this.ccEmails || [],
          replyToEmails: this.replyToEmails || [],
          emailContent: this.message || '',
          emailSubject: this.emailSubject || '',
          reminderEmail: this.reminderEmail[0] || '',
          users: this.users || [],
          taskDueDate: {
            status: this.dueDateStatus || 'no_due_date',
            dueDateAfter: null,
            dueDatePeriod: this.dueDatePeriod || null,
            dueDateOn: this.dueDateOn || null,
          },
          notificationMethod: {
            method: this.notificationMethod || 'email',
            credentialId: this.credentialId,
          },
          reminderUsers: this.reminderUsers || [],
          toDoLabel: this.toDoLabel || 'Not Complete',
          completedLabel: this.completedLabel || 'Completed',
          toDoColor: this.toDoColor || '#F59300',
          completedColor: this.completedColor || '#55A77A',
          reminderEmailMessage: this.reminderEmailMessage || '',
          reminderEmailSubject: this.reminderEmailSubject || '',
          reminderCcEmails: this.reminderCcEmails || [],
          reminderReplyToEmails: this.reminderReplyToEmails || [],
          reminderInterval: this.reminderInterval || 1,
          reminderOnPlaceholderValue: this.reminderOnPlaceholderValue || [],
          reminderType: this.reminderType || 'days',
          reminderFrequency: this.reminderFrequency || 'ONCE',
          reminderLimit: this.reminderLimit || 1,
          reminder: this.reminder || false,
          reminderTimezone: {
            offset: 'GMT+00:00',
            name: 'UTC',
          },
          reminderOption: this.reminderOption || 'time',
          form: {
            formTitle: this.pageTitles[0]?.page_title || 'Form Title',
          },
          linkedComponent: false,
          linkedComponents: [],
          formPlaceholders: {},
          placeholders: {},
          name: this.name,
          lastModified: new Date().toISOString(),
        },

        pages: savedTemplate.pages || {},
        form_length: savedTemplate.form_length || 1,
      },
    };
  }
}

var SequentialFormContainer = new Container();

export default SequentialFormContainer;
